import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import HeaderContainer from "./Components/HeaderContainer";
import Header from "./Components/Header";
import FileManager from "./Components/FileManager";
import AddItem from "./Components/AddItem";
import Filter from "./Components/Filter";
import Search from "./Components/Search";
import HandleCheckboxes from "./Components/HandleCheckboxes";
import ItemList from "./Components/ItemList";
import { Container } from "react-bootstrap";
import "./App.css"; // Importer le fichier CSS pour les styles

function App() {
  const [items, setItems] = useState([]); // Articles à afficher
  const [allItems, setAllItems] = useState([]); // Tous les articles de la base
  const [itemsBuffer, setItemsBuffer] = useState([]); // Articles mis en cache
  const [isWholeStore, setIsWholeStore] = useState(true);
  const [isShoppingList, setIsShoppingList] = useState(false);
  const [isUnchecked, setIsUnchecked] = useState(false);
  const [storeListBtn, setStoreListBtn] = useState('clicked');
  const [shoppingListBtn, setShoppingListBtn] = useState('unclicked');
  const [uncheckedItemsBtn, setUncheckedItemsBtn] = useState('unclicked');

  useEffect(() => {
    const localItems = JSON.parse(localStorage.getItem("localItems")) || [];

    if (localItems.length !== 0) {
      setAllItems(localItems); // Initialiser allItems avec les items locaux
      setItems(sortItemsByName(localItems)); // Initialiser les Items à afficher et les trier par nom
      setItemsBuffer(localItems); // Initialiser le buffer avec les items locaux
    }

    console.log("Par Charles-Henri SAINT-MARS, Version 1.3.0");
  }, []);

  const storeList = (storageName, items) => {
    localStorage.setItem(storageName, JSON.stringify(items));
  };


  // Trier les articles par nom
  const sortItemsByName = (items) => {
    return items.sort((a, b) => a.name.localeCompare(b.name));
  }

  // Ajouter un article au magasin virtuel
  const addItem = (name, price, quantity) => {
    const newItem = {
      id: Date.now(), // Générer un ID unique basé sur le timestamp
      name,
      price: parseFloat(price),
      quantity: parseInt(quantity, 10),
      discount: 0,
      selected: false,
      checked: false,
    };
    setAllItems((prevItems) => {
      const updatedItems = [...prevItems, newItem];

      storeList("localItems", updatedItems); // Appeler storeList avec les items mis à jour
      setItems(sortItemsByName(updatedItems)); // Afficher tous les articles du magasin virtuel et les trier par nom
      setStoreListBtn('clicked');
      setShoppingListBtn('unclicked');
      setUncheckedItemsBtn('unclicked');
      setItemsBuffer(updatedItems);
      return updatedItems;
    });
  };


  // Supprimer un article du magasin virtuel
  const deleteItem = (id) => {
    const isConfirmed = window.confirm(
      "Confirmez-vous la suppression de cet article ?"
    );
    if (!isConfirmed) {
      return;
    } else {
      setAllItems((prevItems) => {
        const updatedItems = prevItems.filter((item) => item.id !== id);
        storeList("localItems", updatedItems); // Appeler storeList avec les items mis à jour
        showFilteredItems(sortItemsByName(updatedItems)); // Afficher les articles filtrés et les trier par nom
        setItemsBuffer(updatedItems);
        return updatedItems;
      });
    }
  };


  // Modifier un article
  const updateItem = (id, name, price, quantity, discount) => {
    setAllItems((prevItems) => {
      const updatedItems = prevItems.map((item) =>
        item.id === id
          ? {
              ...item,
              name,
              price: parseFloat(price),
              quantity: parseInt(quantity, 10),
              discount: parseFloat(discount),
            }
          : item
      );

      storeList("localItems", updatedItems); // Appeler storeList avec les items mis à jour
      showFilteredItems(sortItemsByName(updatedItems)); // Afficher les articles filtrés et les trier par nom
      setItemsBuffer(updatedItems);
      return updatedItems;
    });
  };


  // Mettre à jour l'état 'checked' d'un article
  const updateCheckedItem = (id, checked) => {
    setAllItems((prevItems) => {
      const updatedItems = prevItems.map((item) =>
        item.id === id ? { ...item, checked: checked } : item
      );

      storeList("localItems", updatedItems); // Appeler storeList avec les items mis à jour
      showFilteredItems(sortItemsByName(updatedItems)); // Afficher les articles filtrés et les trier par nom
      setItemsBuffer(updatedItems);
      return updatedItems;
    });
    
  };


  // Mettre à jour les états 'selected' et 'checked' d'un article
  const updateSelectedItem = (id, selected) => {
    setAllItems((prevItems) => {
      const updatedItems = prevItems.map((item) =>
        item.id === id ? { ...item, selected: selected, checked: false } : item
      );

      storeList("localItems", updatedItems); // Appeler storeList avec les items mis à jour      
      showFilteredItems(sortItemsByName(updatedItems)); // Mettre à jour les Items à afficher et les trier par nom
      setItemsBuffer(updatedItems);
      return updatedItems;
    });
  };


  // Décocher tous les articles validés en boutique
  const uncheckAllItems = () => {
    setAllItems((prevItems) => {
      const updatedItems = prevItems.map((item) => ({
        ...item,
        checked: false,
      }));
      storeList("localItems", updatedItems); // Appeler storeList avec les items mis à jour
      showFilteredItems(sortItemsByName(updatedItems)); // Afficher les articles filtrés et les trier par nom
      setItemsBuffer(updatedItems);
      return updatedItems;
    });
  };


  // Décocher tous les articles sélectionnés pour la liste d'achat et non cochés faits (non validés)
  const unselectAllItems = () => {
    setAllItems((prevItems) => {
      const updatedItems = prevItems.map((item) => ({
        ...item,
        selected: false,
      }));
      storeList("localItems", updatedItems); // Appeler storeList avec les items mis à jour
      showFilteredItems(sortItemsByName(updatedItems)); // Afficher les articles filtrés et les trier par nom
      setItemsBuffer(updatedItems);
      return updatedItems;
    });
    uncheckAllItems(); // Décocher tous les articles validés en boutique
  };


  // Filtrer les articles à afficher en fonction des critères sélectionnés
  const filterItems = (isWholeStore, isShoppingList, isUnchecked, updatedItems) => {
    if (updatedItems.length !== 0) setItems(updatedItems);
    else setItems(allItems);

    setItems((prevItems) => {
      // Afficher uniquement les articles sélectionnés pour la liste d'achat
      if (isShoppingList === true && isUnchecked === false) {
        updatedItems = prevItems.filter((item) => item.selected === true);
      }

      // Afficher uniquement les articles sélectionnés pour la liste d'achat et non cochés faits (non validés)
      if (isShoppingList === false && isUnchecked === true) {
        updatedItems = prevItems.filter(
          (item) => item.selected === true && item.checked === false
        );
        setItemsBuffer(updatedItems);
      }

      setIsWholeStore(isWholeStore);
      setIsShoppingList(isShoppingList);
      setIsUnchecked(isUnchecked);
      setItemsBuffer(updatedItems);

      return updatedItems;
    });
  };


  // Afficher les articles filtrés
  const showFilteredItems = (updatedItems) =>{
    if (isWholeStore === true) filterItems(true, false, false, updatedItems);
    else if (isShoppingList === true) filterItems(false, true, false, updatedItems);
    else if (isUnchecked === true) filterItems(false, false, true, updatedItems);
  }


  // Afficher tous les articles du magasin virtuel
  const showAllItems = () => {
    setIsWholeStore(true);
    setItems(sortItemsByName(allItems)); // Afficher tous les articles du magasin et les trier par nom
    setItemsBuffer(allItems);
  };


  // Exporter les données au format JSON
  const exportData = () => {
    const timestamp = Date.now(); // ex : 1721234567890
    const date = new Date(timestamp);
    const year = date.getFullYear(); // ex : 2023
    const month = String(date.getMonth() + 1).padStart(2, "0"); // ex : 10
    const day = String(date.getDate()).padStart(2, "0"); // ex : 01
    const hours = String(date.getHours()).padStart(2, "0"); // ex : 12
    const minutes = String(date.getMinutes()).padStart(2, "0"); // ex : 30
    const seconds = String(date.getSeconds()).padStart(2, "0"); // ex : 45
    const formattedDate = `${year}-${month}-${day} ${hours}.${minutes}.${seconds}`; // ex : 2023-10-01 12.30.45

    // Convertir les données en JSON formaté
    const dataStr = JSON.stringify(allItems, null, 2);

    // Créer un blob à partir des données JSON
    const blob = new Blob([dataStr], { type: "application/json" });
    //console.log("Contenu de blob : ", blob);

    // Créer une URL pour le blob
    const url = URL.createObjectURL(blob);
    //console.log("Contenu de url : ", url);

    // Créer un lien pour télécharger le fichier
    const link = document.createElement("a");
    link.href = url;
    link.download = `courses ${formattedDate}.json`; // Nom du fichier exporté
    link.click(); // Déclencher le téléchargement

    // Libérer l'URL après le téléchargement
    URL.revokeObjectURL(url);
  };


  // Importer les données à partir d'un fichier JSON
  const importData = (file) => {
    //console.log("Contenu de file : ", file);

    // Créer un FileReader pour lire le fichier
    const reader = new FileReader();

    // Configurer le comportement du FileReader en définissant la fonction de rappel de l'événement reader.onload
    reader.onload = (event) => {
      try {
        //console.log("Contenu du fichier JSON : ", event.target.result);

        // Tenter de convertir le contenu du fichier en JSON en tableau d'objets JavaScript
        const importedItems = JSON.parse(event.target.result);
        if (Array.isArray(importedItems)) {
          // Vérifier si le contenu est un tableau
          setAllItems(importedItems); // Mettre à jour les données
          setItems(sortItemsByName(importedItems)); // Afficher les articles importés et les trier par nom
          setItemsBuffer(importedItems);
          storeList("localItems", importedItems); // Sauvegarder dans le localStorage
          alert("Importation réussie !");
        } else {
          alert("Le fichier JSON n'est pas valide.");
        }
      } catch (error) {
        alert(
          "Erreur lors de l'importation : le fichier n'est pas un JSON valide."
        );
      }
    };

    reader.readAsText(file); // Lire le fichier comme texte
  };


  // Gérer la recherche d'articles par nom
  const handleSearch = (query) => {
    if (!query) {
      setItems(itemsBuffer); // Si la  requête est vide, réinitialiser les items à afficher
      return;
    }

    const lowerQuery = query.toLowerCase();

    setItems(
      itemsBuffer.filter((item) => item.name.toLowerCase().includes(lowerQuery))
    );
  };


  // Supprimer tous les articles du magasin virtuel
  // const deleteAllItems = () => {
  //   setAllItems([]); // Vider tous les items
  //   setItems([]); // Vider les Items à afficher
  //   setItemsBuffer([]);
  //   storeList("localItems", []); // Appeler storeList avec un tableau vide
  //   setIsFiltered(false);
  //   //alert("Tous les articles ont été supprimés.");
  // };


  // Calculer le montant total et le nombre total d'articles
  const totalAmount = items.reduce((sum, item) => sum + item.price * item.quantity - item.discount, 0);
  const totalItems = items.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <Container className='my-4'>
      <HeaderContainer>
        <Header totalAmount={totalAmount} totalItems={totalItems} />
        <Filter 
          filterItems={filterItems}
          showAllItems={showAllItems}
          storeListBtn={storeListBtn}
          setStoreListBtn={setStoreListBtn}
          shoppingListBtn={shoppingListBtn}
          setShoppingListBtn={setShoppingListBtn}
          uncheckedItemsBtn={uncheckedItemsBtn}
          setUncheckedItemsBtn={setUncheckedItemsBtn}
        />
        <Search onSearch={handleSearch} />
      </HeaderContainer>
      <ItemList
        items={items}
        deleteItem={deleteItem}
        updateItem={updateItem}
        updateCheckedItem={updateCheckedItem}
        updateSelectedItem={updateSelectedItem}
      />
      <FileManager exportData={exportData} importData={importData} />
      <HandleCheckboxes
        uncheckAllItems={uncheckAllItems}
        unselectAllItems={unselectAllItems}
      />
      <AddItem addItem={addItem} />
    </Container>
  );
}

export default App;
